import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "loaderMsg"
};
const _hoisted_2 = {
  key: 0,
  class: "loaderFullScreenBackdrop"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", {
    class: _normalizeClass(['spinnerContainer', _ctx.fullScreen ? 'fullScreen' : ''])
  }, [_createElementVNode("div", {
    class: _normalizeClass([[_ctx.spinnerSize, _ctx.spinnerColor], "spinners"])
  }, [...(_cache[0] || (_cache[0] = [_createElementVNode("svg", {
    width: "1em",
    height: "1em"
  }, [_createElementVNode("circle", {
    cx: "0.5em",
    cy: "0.5em",
    r: "0.45em"
  })], -1)]))], 2), _ctx.loaderMsg ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.$t('logout.loaderMsg')), 1)) : _createCommentVNode("", true)], 2), _ctx.fullScreen ? (_openBlock(), _createElementBlock("div", _hoisted_2)) : _createCommentVNode("", true)]);
}